// extracted by mini-css-extract-plugin
export default {"ClientDetail":"ClientDetail_ClientDetail__pK1UD","tableResponsive":"ClientDetail_tableResponsive__mMw9V"};